import { render, staticRenderFns } from "./DraggableListGroup.vue?vue&type=template&id=373d992c&scoped=true&"
import script from "./DraggableListGroup.vue?vue&type=script&lang=js&"
export * from "./DraggableListGroup.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListGroup.vue?vue&type=style&index=0&id=373d992c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373d992c",
  null
  
)

export default component.exports